module.exports = __webpack_public_path__ + "img/KMS-J-16.750a4d24.svg";